export const baseComparisonItem = {
  fileOne: [],
  fileTwo: [],

  // Used to store the image objects after reading from the fileOne and fileTwo
  fileOneImage: [],
  fileTwoImage: [],

  fileOneDetails: { name: "", size: 0, caption: "" },
  fileTwoDetails: { name: "", size: 0, caption: "" },

  imageZoomSplit: 100,
  positionSplit: { x: 0, y: 0 },
  lockToggleSplit: true,

  imageZoomOpacity: 100,
  positionOpacity: { x: 0, y: 0 },
  lockToggleOpacity: true,

  imageOnePositionSplit: { x: 0, y: 0 },
  imageTwoPositionSplit: { x: 0, y: 0 },
  imageOneZoomSplit: 1,
  imageTwoZoomSplit: 1,

  imageOnePositionOpacity: { x: 0, y: 0 },
  imageTwoPositionOpacity: { x: 0, y: 0 },
  imageOneWidth: 100,
  imageTwoWidth: 100,
  imageOneRotation: 0,
  imageTwoRotation: 0,
  imageOneOpacity: 100,
  imageTwoOpacity: 75,
  imageOneZoomOpacity: 1,
  imageTwoZoomOpacity: 1,
};

// TODO: Implement this object
const baseComparisonItemUpdate = {
  fileOne: {
    fileObject: [],
    imageObject: [],
    fileDetails: { name: "", size: 0, caption: "" },
  },
  fileTwo: {
    fileObject: [],
    imageObject: [],
    fileDetails: { name: "", size: 0, caption: "" },
  },

  pairConfiguration: {
    imageZoomSplit: 100,
    positionSplit: { x: 0, y: 0 },
    lockToggleSplit: true,

    imageZoomOpacity: 100,
    positionOpacity: { x: 0, y: 0 },
    lockToggleOpacity: true,

    imageOnePositionSplit: { x: 0, y: 0 },
    imageTwoPositionSplit: { x: 0, y: 0 },
    imageOneZoomSplit: 1,
    imageTwoZoomSplit: 1,

    imageOnePositionOpacity: { x: 0, y: 0 },
    imageTwoPositionOpacity: { x: 0, y: 0 },
    imageOneWidth: 100,
    imageTwoWidth: 100,
    imageOneRotation: 0,
    imageTwoRotation: 0,
    imageOneOpacity: 100,
    imageTwoOpacity: 75,
    imageOneZoomOpacity: 1,
    imageTwoZoomOpacity: 1,
  },
};
